"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateInfoRequest = void 0;
var UpdateInfoRequest = /** @class */ (function () {
    function UpdateInfoRequest() {
    }
    return UpdateInfoRequest;
}());
exports.UpdateInfoRequest = UpdateInfoRequest;
;
//# sourceMappingURL=updateInfo.request.js.map